// extracted by mini-css-extract-plugin
export default {"modal-overlay":"Modal_modal-overlay__8HdBb","modal":"Modal_modal__DJDMv","modal-close":"Modal_modal-close__INoGD","cancel_icon":"Modal_cancel_icon__JnAwk"};